import { render, staticRenderFns } from "./r-hero-kind.vue?vue&type=template&id=87c8c91c"
import script from "./r-hero-kind.vue?vue&type=script&lang=js"
export * from "./r-hero-kind.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('87c8c91c')) {
      api.createRecord('87c8c91c', component.options)
    } else {
      api.reload('87c8c91c', component.options)
    }
    module.hot.accept("./r-hero-kind.vue?vue&type=template&id=87c8c91c", function () {
      api.rerender('87c8c91c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/hero/r-hero-kind.vue"
export default component.exports